/**
 * Single entry point for GTM. Every analytics vendor (GA4, LinkedIn, Clarity,
 * HubSpot) is configured as a tag inside the GTM container (REACT_APP_GTM_ID),
 * so the app only announces what happened and the container decides who
 * receives it. Do not add vendor scripts or gtag calls to the app.
 */
export const pushDataLayerEvent = (event, payload = {}) => {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
};

export default pushDataLayerEvent;
